<div *ngIf="data != null && data?.IdPopup">
</div>

<ng-template #popupModal let-modal>
  <button (click)="closePopup(modal)" id="popup-modal-close-button" type="button" class="btn-close" aria-label="Close"></button>
  <div class="PopUp_content external-html" [innerHtml]="htmlContent" (click)="onLinkClick($event)" runScripts></div>
</ng-template>

